import React from 'react';
import { genres } from '../mock';

const GenreGrid = () => {
  return (
    <section className="px-6 mt-10">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-display text-2xl md:text-3xl text-white">Browse Genres</h2>
        <button className="text-xs uppercase tracking-wider text-neutral-400 hover:text-white transition-colors">See all</button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {genres.map((g) => (
          <div
            key={g.id}
            className="relative h-32 md:h-36 rounded-xl overflow-hidden cursor-pointer group"
          >
            <div
              className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-110 transition-transform duration-500"
              style={{ backgroundImage: `url(${g.image})` }}
            />
            <div className={`absolute inset-0 bg-gradient-to-br ${g.color} opacity-70 group-hover:opacity-60 transition-opacity`} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="relative h-full p-4 flex items-end">
              <h3 className="font-display text-xl md:text-2xl text-white leading-tight drop-shadow-lg">
                {g.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GenreGrid;
